// JUST TO HANDLE REDUX LOGIC, DISPATCHES ACTIONS, ACCESSES GLOBAL STATE
// IMPORTANT	--DO NOT DO CALLS TO (API)-- PLEASE USE SERVICE FILE

import { createAsyncThunk } from '@reduxjs/toolkit';
import { fetchViolationsFromFirestore, updateViolationFromFirestore } from './violationsService';

export const fetchViolations = createAsyncThunk('violationsReport/fetchViolations', async (venueID, { getState }) => {
  const state = getState();
  const selectedWeek = state.violationsReport.selectedWeek;

  // Get the Violations from firestore
  const violations = await fetchViolationsFromFirestore(venueID, selectedWeek);
  return violations;
});

export const updateViolation = createAsyncThunk(
  'violationsReport/updateViolation',
  async (updatedFields, { getState }) => {
    const state = getState();
    const violationId = state.violationsReport.selectedViolation.id;

    const updatedViolation = await updateViolationFromFirestore(updatedFields, violationId);

    return updatedViolation;
  }
);
